import Vue from 'vue'
import VueSlider from 'vue-slider-component'
import './vue-slider-style.scss'

Vue.component('VueSlider', VueSlider)
